import { Component, inject, signal, TemplateRef, viewChild, ViewContainerRef } from "@angular/core";
import { NavigationEnd, Router } from "@angular/router";
import { BottomDrawerService } from "@shared/services/bottom-drawer.service";
import { takeUntilDestroyed } from "@angular/core/rxjs-interop";
import { bottomSlideAnimation } from "@shared/animations/bottom-slide.animation";
import { IconComponent } from "@shared/components/atoms/icon/icon.component";
import { TranslatePipe } from "@ngx-translate/core";
import { AccountSideNavigationComponent } from "@features/account/components/account-side-navigation/account-side-navigation.component";
import { filter } from "rxjs";

@Component({
  selector: "app-mobile-account-drawer",
  imports: [IconComponent, TranslatePipe, AccountSideNavigationComponent],
  templateUrl: "./mobile-account-drawer.component.html",
  styleUrl: "./mobile-account-drawer.component.scss",
  animations: [bottomSlideAnimation],
  providers: [BottomDrawerService],
})
export class MobileAccountDrawerComponent {
  drawerTemplate = viewChild.required<TemplateRef<unknown>>("drawerTemplate");
  isOpen = signal<boolean>(false);

  private readonly bottomDrawerService = inject(BottomDrawerService);
  private readonly viewContainerRef = inject(ViewContainerRef);
  private readonly router = inject(Router);

  constructor() {
    this.listenDrawerOpenState();
    this.listenNavigationEvents();
  }

  toggle(): void {
    if (!this.bottomDrawerService.isOpen()) {
      this.open();
    } else {
      this.close();
    }
  }

  open(): void {
    this.bottomDrawerService.open(this.drawerTemplate(), this.viewContainerRef);
  }

  close(): void {
    this.bottomDrawerService.close();
  }

  private listenDrawerOpenState(): void {
    this.bottomDrawerService.isOpen$.pipe(takeUntilDestroyed()).subscribe((isOpen) => {
      this.isOpen.set(isOpen);
    });
  }

  private listenNavigationEvents(): void {
    this.router.events
      .pipe(
        filter((event) => event instanceof NavigationEnd),
        takeUntilDestroyed(),
      )
      .subscribe(() => {
        if (this.isOpen()) {
          this.close();
        }
      });
  }
}
